

const imageOutputStyle = {
    imageStyle: {
      maxWidth: '100%',
      marginTop: '10px'
    },
    figureStyle: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '20px 0',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
    },
    figcaptionStyle: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      padding: '5px 10px',
      fontSize: '12px',
      borderRadius: '2px',
      cursor: 'default',
      fontStyle: 'italic',
      lineHeight: '16px'
    }
  };
  
  export default imageOutputStyle;